import { vplApi } from '@/api';

export default {
  fetchPortList() {
    return vplApi.get('/v1/ports');
  },
};
